import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { isMobileDevice } from 'src/utils/util';

const isMobile = isMobileDevice();

export const ImportantNotice = styled.h2`
    color: #170f5f;
    width: 143px;
    height: 31px;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: -3px;
    font-family: 'AvenirNextWorld Demi';
    ${media.mobileDevice`
        font-size: 16px;
        width: 100%;
        `}
`;

export const MsgText = styled.p`
    font-size: 14px;
    color: #333;
    width: 400px;
    ${media.mobileDevice`
        font-size: 12px;
        width: 100%;
    `}
`;

export const ButtonTexts = styled.div`
    display: flex;
    justify-content: space-evenly;
    margin-top: -3px;
    ${media.mobileDevice`
        flex-direction: row;
        align-items: center;
    `}
`;
export const ReturnToCartText = styled.p`
    color: #1010eb;
    width: 120px;
    height: 16px;
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    line-height: 16px;
    white-space: nowrap;
    ${media.mobileDevice`
        width: 100%;
        text-align: center;
    `}
`;

export const AcceptContinueText = styled.p`
    color: #ffffff;
    width: 132px;
    height: 16px;
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    line-height: 16px;
    ${media.mobileDevice`
        width: 100%;
        text-align: center;
    `}
`;
export const ResponsiveSpan = styled.span`
    display: block;
    font-size: 14px;
    font-weight: 400;
    line-height: 24.33px;

    ${media.mobileDevice`
        display: block;
        font-size: 11px;
    `}
`;
export const ProductList = styled.div`
    margin-bottom: 20px;
`;

export const ProductItem = styled.div`
    font-size: 14px;
    color: #333;
    line-height: 1.6;
    margin-bottom: -3px;

    ${media.mobileDevice`
        font-size: 12px;
        margin-bottom: 0;
    `}
`;
